module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./TransactionListView.js"));
	}, "TransactionListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransactionListView!./src/pages/Store/Wallet/TransactionList/TransactionListView.js
// module id = 2144
// module chunks = 367